import React, { useRef, useEffect, ChangeEvent } from 'react';

import classNames from 'classnames';
// @ts-ignore
import isMobile from 'ismobilejs';

import Utils from '../../../../../../../../services/Utils';

import connectAuth, { IAuthMapStateToProps, IConnectedProps } from '../../../../hooks/connectAuth';

import Input from '../../../../../Common/Form/Input/Input';
import { multipleActions } from '../../../../Store/ContainerReducer';
import { IAuthState } from '../../../../Store/Reducers';
import { Types, initialState as reducerInitialState } from '../../../../Store/SignUpReducer';
import TimePicker from './TimePicker';
import TimeSelectorIcon from './TimeSelectorIcon';


interface ITimeSelectorProps {
    hour: string,
    reset: boolean,
    error: string,
    minute: string,
    touched: boolean,
    inputTime: boolean,
    selectedHour: string,
    openTimePicker: boolean,
    customPlaceholder?: string,
    checkedWithoutHour: boolean,
}

type TTimeSelectorProps = IConnectedProps<ITimeSelectorProps>;

const initialState = reducerInitialState.SignUp.birthData.birthHour.timeState;

const TimeSelector: React.FC<TTimeSelectorProps> = ({ intl, dispatch, ...props }) => {
    const input = useRef<HTMLInputElement>(null);

    const {
        hour,
        reset,
        error,
        minute,
        touched,
        inputTime,
        selectedHour,
        openTimePicker,
        customPlaceholder,
        checkedWithoutHour
    } = props;

    const placeholder = customPlaceholder || intl.formatMessage({ id: 'authFunctional.timeSelector.placeholder' });

    const handleBlurTime = () => {
        if (!touched || openTimePicker || (selectedHour && selectedHour.length === 5)) return;

        dispatch({
            type: Types.CHANGE_HOUR_DATA,
            data: { error: intl.formatMessage({ id: 'authFunctional.errors.invalidHour' }) }
        });
    };

    const handleClickIcon = () => multipleActions(dispatch, [
        {
            type: Types.CHANGE_HOUR_DATA,
            data: { openTimePicker: true }
        },
        {
            type: Types.CHANGE_DATE_DATA,
            data: { openDatePicker: false }
        },
        {
            type: Types.CHANGE_TIME_STATE,
            data: { touched: true }
        }
    ]);

    const handleChangeTime = () => {
        if (touched) return;

        dispatch({
            type: Types.CHANGE_TIME_STATE,
            data: { touched: true }
        });
    };

    const handleFocusInput = () => dispatch({
        type: Types.CHANGE_HOUR_DATA,
        data: { openTimePicker: true }
    });

    useEffect(() => {
        if (!isMobile.phone || !inputTime || !input.current) return;

        input.current.click();
    }, [inputTime]);

    useEffect(() => {
        if (!checkedWithoutHour) return;

        dispatch({
            type: Types.CHANGE_TIME_STATE,
            data: { selectedHour: '' }
        });
    }, [dispatch, checkedWithoutHour]);

    useEffect(() => {
        if (!selectedHour || typeof selectedHour !== 'string') return;

        const arrTime = selectedHour.split(':');

        dispatch({
            type: Types.CHANGE_TIME_STATE,
            data: {
                hour: (arrTime.length > 1) ? arrTime[0] : '',
                minute: (arrTime.length > 1) ? arrTime[1] : ''
            }
        });
    }, [dispatch, selectedHour]);

    useEffect(() => {
        if (!reset || selectedHour === hour) return;

        dispatch({
            type: Types.CHANGE_TIME_STATE,
            data: { ...initialState }
        });
    }, [dispatch, hour, reset, selectedHour]);

    const disabled = checkedWithoutHour || openTimePicker;

    const disableClass = classNames(
        'auth-functional__input-time',
        { 'auth-functional__input-time--disabled': disabled }
    );

    const inputValue = Utils.convertHourToUs(selectedHour);
    const visible = inputTime || (hour !== '' || minute !== '');
    const trailingTabIndex = (selectedHour && selectedHour.length === 5 && !error) ? -1 : 0;
    return (
        <>
            <Input
                order={3}
                ref={input}
                tabIndex={0}
                error={error}
                id="birth-time"
                visible={visible}
                value={inputValue}
                disabled={disabled}
                onBlur={handleBlurTime}
                className={disableClass}
                placeholder={placeholder}
                onFocus={handleFocusInput}
                onChange={handleChangeTime}
            >
                <TimeSelectorIcon
                    disabled={disabled}
                    onClick={handleClickIcon}
                    tabIndex={trailingTabIndex}
                />
            </Input>

            <TimePicker
                intl={intl}
                onTimeChanged={() => { }}
            />
        </>
    );
};

const mapStateToProps: IAuthMapStateToProps<ITimeSelectorProps> = (state, isComparison = false) => ((!isComparison)
    ? {
        reset: (state as IAuthState).Container.reset,
        error: (state as IAuthState).SignUp.birthData.birthHour.error,
        checkedWithoutHour: (state as IAuthState).SignUp.checkedWithoutHour,
        hour: (state as IAuthState).SignUp.birthData.birthHour.timeState.hour,
        minute: (state as IAuthState).SignUp.birthData.birthHour.timeState.minute,
        touched: (state as IAuthState).SignUp.birthData.birthHour.timeState.touched,
        selectedHour: (state as IAuthState).SignUp.birthData.birthHour.selectedHour,
        inputTime: (state as IAuthState).SignUp.birthData.birthHour.timeState.inputTime,
        openTimePicker: (state as IAuthState).SignUp.birthData.birthHour.openTimePicker,
        customPlaceholder: (state as IAuthState).Container.communication.placeholderBirthTime
    } :
    {
        hour: state.hour,
        reset: state.reset,
        error: state.error,
        minute: state.minute,
        touched: state.touched,
        inputTime: state.inputTime,
        selectedHour: state.selectedHour,
        openTimePicker: state.openTimePicker,
        customPlaceholder: state.customPlaceholder,
        checkedWithoutHour: state.checkedWithoutHour
    }
);

export default connectAuth(mapStateToProps)(TimeSelector);
